import _ from 'lodash';

export const unmarshalGraphqlEdges = (obj, removeEdgesAttr = false) => {
  const clone = _.cloneDeep(obj);

  for (const key of Object.keys(clone)) {
    if (key === 'edges') {
      const plain = [];
      for (const item of clone[key] || []) {
        const node = item && item.node;
        if (node == null) continue; // skip null nodes from partial GraphQL results
        plain.push({ ...node });
      }
      clone[key] = plain;
    } else if (_.has(clone, `${key}.edges`)) {
      const plain = [];
      const nestedEdges = _.get(clone, `${key}.edges`) || [];
      for (const item of nestedEdges) {
        const node = item && item.node;
        if (node == null) continue; // skip null nodes from partial GraphQL results
        plain.push({ ...node });
      }
      clone[key] = plain;
    }
  }
  if (removeEdgesAttr) {
    if (typeof clone.edges !== 'undefined') {
      return clone.edges;
    }
  }
  return clone;
};
